// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___2u3Ex","icon":"styles__icon___34SEi","title":"styles__title___2N5FQ","description":"styles__description___Oq6S3","action":"styles__action___35mw4"};